import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import Gallery from "./Gallery";
import {
  Switch,
  FormControlLabel,
  Drawer,
  Divider,
  IconButton,
  Button,
  Grid
} from "@material-ui/core";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import SyncIcon from "@mui/icons-material/Sync";
import ColorFilter from "./ColorFilter";
import ShapeFilter from "./ShapeFilter";
import SizeFilter from "./SizeFilter";
import SortingFilter from "./SortingFilter";
import FilterListIcon from '@mui/icons-material/FilterList';
import TuneIcon from '@mui/icons-material/Tune';
import CustomOverlayDrawer from "./CustomOverlayDrawer";
import { useInView } from "react-intersection-observer";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { motion } from 'framer-motion';
import SubSectionsCard from '../SubSectionsCard';
import BottomSection from '../BottomSection';
import BottomSectionMobile from "../BottomSectionMobile";
import Countdown from "../Countdown";
import { Link } from 'react-router-dom';
import SEO, { createCollectionSchema, createBreadcrumbSchema } from './SEO';

import ImageTheme1 from '../images/dropdown_image.png'
import ImageThemeFantasy from '../images/theme_fantasy.png'
import ImageThemePopArt from '../images/theme_popart.png'
import ImageThemePhoto from '../images/theme_photo.png'
import ImageThemeFuture from '../images/theme_future.png'
import ImageThemeBohem from '../images/theme_bohem.png'
import ImageThemeHumans from '../images/theme_humans.png'
import ImageThemeAbstract from '../images/theme_abstract.png'
import ImageThemeAnimal from '../images/theme_animal.png'
import ImageThemeNature from '../images/theme_nature.png'
import ImageThemeNews from '../images/theme_news.png'
import ImageThemeTop from '../images/theme_topp.png'
import ImageThemePaket from '../images/theme_paket.png'
import ImageThemeViechle from '../images/theme_viechle.png'
import ImageThemeSale from '../images/theme_sale.png'
import ImageThemeIllustration from '../images/theme_illustration.png'
import ContactComponent from "../link_components/ContactComponent";
import CommonQuestions from "../link_components/CommonQuestions";
import PurchaseConditions from "../link_components/PurchaseConditions";
import DeliveryInformation from "../link_components/DeliveryInformation";
import ThankYou from "../link_components/ThankYou";
import Cookiepolicy from "../link_components/Cookiepolicy";
import IntegrityPolicy from "../link_components/IntegrityPolicy";
import AboutUs from "../link_components/AboutUs";
import PosterInfo from "../link_components/PosterInfo";
import PageUnderConstruction from "../link_components/PageUnderConstruction";
import { useMediaQuery } from '@material-ui/core';
import LoadingOverlay from "./LoadingOverlay";
import PaymentFailed from "../link_components/PaymentFailed";
import { maxWidth } from "@mui/system";

gsap.registerPlugin(ScrollTrigger);

const GalleryPage = ({ signedUrls, setCookieConsentGiven, loadCount, setLoadCount, setImageDisplayUrls,discountPercentage, isMobileView,isTabletView,previousLocation, scrollPosition, setScrollPosition, currentLocation, setFavoritePoster, favoritePoster, onImageClick, searchValue, imageDisplayUrl, imageDisplayUrls, searchResult, setOpenSidebar,setOpenCookieBar }) => {
  const fixedIconsRef = useRef(null);
  const filterButtonRef = useRef(null);
  const sortButtonRef = useRef(null);
  const [showFixedIcons, setShowFixedIcons] = useState(false);
  const { style, category, imageId } = useParams();
  const [toggleState, setToggleState] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState("filter");
  const elementRef = useRef(null);
  const [displayFixedButtons, setDisplayFixedButtons] = useState(true)
  const buttonRef = useRef(null);
  const boxRef = useRef(null);
  const isMobileView2 = useMediaQuery('(max-width:790px)');
  const isTabletView2 = useMediaQuery('(max-width:810px)');
  const [displayButtons, setDisplayButtons] = useState("visible")
  const [showComponent, setShowComponent] = useState(() => ContactComponent);
  const [showComponents, setShowComponents] = useState(false);

  const handleScrollPosition = () => {
    // Store current scroll position in the parent's state

    const currentScrollPos = window.scrollY;
    console.log(currentScrollPos)
    setScrollPosition(currentScrollPos);
  
  };

  // useEffect(() => {
  //   if(scrollPosition!==0){}
  // }, []);

  useEffect(() => {
    ScrollTrigger.create({
      trigger: buttonRef.current,
      start: 'top 100px',
      end: 'top -600px', // fires when the bottom of the button is at the top of the viewport

      onEnter: () => {
        
        setDisplayFixedButtons(false)
        
      },
      onLeave: () => {
        
        setDisplayFixedButtons(true)
        
      },
      onEnterBack: () => {
        
        setDisplayFixedButtons(false)
        
      },
      onLeaveBack: () => {
        
        setDisplayFixedButtons(true)
        
      },
    });
    

    gsap.from(boxRef.current, {
      autoAlpha: 0,
      y: 50,
      ease: 'none',
      scrollTrigger: {
        trigger: buttonRef.current,
        start: 'top center',
        toggleActions: 'play none none reverse',
      },
    });
  }, []);


  const [visible, setVisible] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0,
  });


  
  const [openFrameMenu, setOpenFrameMenu] = useState(false);

  const toggleDrawerFrame = () => {
    setOpenFrameMenu(!openFrameMenu);
  };


  const checkScrollPosition = () => {
    if (elementRef.current) {
      const elementTop = elementRef.current.getBoundingClientRect().top;
      
      // If the elementTop is less than or equal to 0, it means the element has been scrolled past the top of the viewport.
      if (elementTop <= 0) {
        
      } else {
        
      }
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            setShowFixedIcons(true);
            
          } else {
            setShowFixedIcons(false);
            
          }
        });
      },
      { threshold: 0 }
    );
  
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
  
    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);
  
  const handleToggleChange = () => {
    setToggleState(!toggleState);
  };

  const openDrawer = (mode) => {
    setDrawerMode(mode);
    setDrawerOpen(true);
    
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };
  const [selectedSortOn, setSelectedSortOn] = useState("")

  const [displayThemeData, setDisplayThemeData] = useState(
    {

      title: "Topplista",
      image: ImageTheme1,
      category: '',
      text: "posters för alla sorter"
    }
  )



  useEffect(()=>{
    
    if (style==="rabatt"){
      setDisplayThemeData(
        {

          title: "Rabatt",
          image: ImageThemeSale,
          category: category,
          text: "Utforska vår rabattförsäljning på alla sorters posters! Oavsett om du är intresserad av abstrakta illustrationer av gorillor, fotorealistiska skildringar av bilar eller bohemiska fantasibilder, har vi något för dig."
        }
      )
    }
    if (style==="abstract"){
      setDisplayThemeData(
        {

          title: "Abstract",
          image: ImageThemeAbstract,
          category: category,
          text: "Abstrakt konst bjuder in till tolkning och uppmuntrar till en djupare förståelse. Varje abstrakt verk kan presentera geometriska former, slumpmässiga penseldrag, och mycket mer."
        }
      )
    }
    if (style==="bohemian"){
      setDisplayThemeData(
        {

          title: "Bohemiskt",
          image: ImageThemeBohem,
          category: category,
          text: "Bohemian-posters är karaktäristiska för sin livliga och ofta eklektiska design. De inkluderar ofta naturliga element, etniska mönster, vintage-inspirerade tryck och levande färger."
        }
      )
    }
    if (style==="futuristic"){
      setDisplayThemeData(
        {

          title: "Framtid",
          image: ImageThemeFuture,
          category: category,
          text: "Futuristiska posters erbjuder en blick in i framtidens värld, med sofistikerade teknologiska innovationer, avantgardiska arkitektoniska strukturer och ofta en titt på det okända. "
        }
      )
    }

    if (style==="illustration"){
      setDisplayThemeData(
        {

          title: "Illustration",
          image: ImageThemeIllustration,
          category: category,
          text: "Illustrationsposters är mycket varierande, från söta och lekfulla bilder till sofistikerade skisser och teckningar. De kan visa allt från vardagsscener, vackra landskap, porträtt till abstrakta motiv."
        }
      )
    }

    if (style==="animals-1"){
      setDisplayThemeData(
        {

          title: "Djur",
          image: ImageThemeAnimal,
          category: category,
          text: "Fantasy-posters tar betraktaren till en annan värld full av mytiska varelser, magiska landskap, hjältar och äventyr."
        }
      )
    }

    if (style==="humans-1"){
      setDisplayThemeData(
        {

          title: "Människor",
          image: ImageThemeHumans,
          category: category,
          text: "Fantasy-posters tar betraktaren till en annan värld full av mytiska varelser, magiska landskap, hjältar och äventyr."
        }
      )
    }
    if (style==="vehicle-1"){
      setDisplayThemeData(
        {

          title: "Fordon",
          image: ImageThemeViechle,
          category: category,
          text: "Fantasy-posters tar betraktaren till en annan värld full av mytiska varelser, magiska landskap, hjältar och äventyr."
        }
      )
    }
    if (style==="posterpaket"){
      setDisplayThemeData(
        {

          title: "Posterpaket",
          image: ImageThemePaket,
          category: category,
          text: "Fantasy-posters tar betraktaren till en annan värld full av mytiska varelser, magiska landskap, hjältar och äventyr."
        }
      )
    }
    if (style==="topplista"){
      setDisplayThemeData(
        {

          title: "Topplista",
          image: ImageThemeTop,
          category: category,
          text: "Topplista-posters representerar de mest älskade och populära designerna. Dessa posters är valda av vår community för deras enastående kreativitet, skönhet och förmåga att engagera och inspirera."
        }
      )
    }
    if (style==="nyheter"){
      setDisplayThemeData(
        {

          title: "Nyheter",
          image: ImageThemeNews,
          category: category,
          text: "Utforska de senaste tillskotten i vår samling med Nyheter-posters. Här finner du de nyaste trenderna, färska konstnärliga uttryck och innovativa designidéer som precis har landat i vår butik."
        }
      )
    }
    if (style==="nature-1"){
      setDisplayThemeData(
        {

          title: "Natur",
          image: ImageThemeNature,
          category: category,
          text: "Denna naturposter kollektion representerar en mångfald av landskap, element och scener som vår vackra planet har att erbjuda. Presenterad i alla unika stilar som Postertopia tillhandahåller, varje bild erbjuder en ny synvinkel på den naturliga världen och fångar dess skönhet och mångsidighet."
        }
      )
    }
    if (style==="fantasy"){
      setDisplayThemeData(
        {

          title: "Fantasy",
          image: ImageThemeFantasy,
          category: category,
          text: "Fantasy-posters tar betraktaren till en annan värld full av mytiska varelser, magiska landskap, hjältar och äventyr."
        }
      )
    }
    if (style==="pop-art"){
      setDisplayThemeData(
        {

          title: "Pop-Art",
          image: ImageThemePopArt,
          category: category,
          text: "Pop-Art-posters ger ett modigt och levande uttryck. Med färgglada och ofta kontrasterande färger, kändisporträtt, allmänna varumärken och vardagliga föremål, är dessa verk ett statement i sig."
        }
      )
    }
    if (style==="photography"){
      setDisplayThemeData(
        {

          title: "Fotografi",
          image: ImageThemePhoto,
          category: category,
          text: "Fotografi posters kan föreviga alla typer av motiv: från vackra landskap, fascinerande stadsbilder, djurliv till stilla liv och mer. "
        }
      )
    }



      else if (style === "abstract" && category === "nature") {
        setDisplayThemeData({
          title: "Abstrakt",
          image: ImageThemeAbstract,
          category: category,
          text: "Abstrakt naturkonst bjuder på ett nytt, tolkningsbart sätt att se på våra omgivningar. Varje penseldrag, varje färgton, kan föreställa en aspekt av naturen som vi inte sett förut, och det är just den mystiken som gör dessa verk så spännande."
        });
      } else if (style === "abstract" && category === "animals") {
        setDisplayThemeData({
          title: "Abstrakt",
          image: ImageThemeAbstract,
          category: category,
          text: "Djuren får nytt liv i dessa abstrakta verk, där färg och form skildrar deras essens. Varje konstverk är en djupdykning i djurets själ, en resa som skildrar dess karaktär på ett visst och ofta oväntat sätt."
        });
      } else if (style === "abstract" && category === "humans") {
        setDisplayThemeData({
          title: "Abstrakt",
          image: ImageThemeAbstract,
          category: category,
          text: "Abstrakta människoskildringar utmanar oss att se bortom det bokstavliga, och in i själva essensen av mänskligt liv och erfarenheter. Genom att bryta ner människokroppen till abstrakta former, erbjuder dessa konstverk en inre blick in i mänskliga känslor, tankar och drömmar."
        });
      } else if (style === "abstract" && category === "creatures") {
        setDisplayThemeData({
          title: "Abstrakt",
          image: ImageThemeAbstract,
          category: category,
          text: "Abstrakta varelsemotiv låter fantasin löpa fritt, med suggestiva former och färger som skapar ett mysterium kring varelsens natur. Dessa konstverk tar oss med till en fantasivärld, där mytiska varelser tar form och skapar berättelser genom sin abstrakta representation."
        });
      } else if (style === "abstract" && category === "architecture") {
        setDisplayThemeData({
          title: "Abstrakt",
          image: ImageThemeAbstract,
          category: category,
          text: "Abstrakt arkitekturkonst transformerar byggnader och strukturer till visuellt stimulerande former och mönster. Genom att förenkla och abstrahera arkitekturens linjer och former, blir dessa konstverk till en hyllning till de geometriska mönster och designprinciper som ligger till grund för vår byggda miljö."
        });
      } else if (style === "bohemian" && category === "nature") {
        setDisplayThemeData({
          title: "Bohemiskt",
          image: ImageThemeBohem,
          category: category,
          text: "Bohemiska naturposter förmedlar en känsla av frihet och vildhet, precis som naturen själv. De är präglade av livliga och ofta eklektiska design, ofta med naturliga element och levande färger."
        });
      } else if (style === "bohemian" && category === "animals") {
        setDisplayThemeData({
          title: "Bohemiskt",
          image: ImageThemeBohem,
          category: category,
          text: "Dessa bohemiska djurposters bjuder på en levande och eklektisk mix av design. Varje djur presenteras i en unik och karaktäristisk stil, som kombinerar naturliga element med djärva färger och fantasifulla mönster"
        });
      } else if (style === "bohemian" && category === "humans") {
        setDisplayThemeData({
          title: "Bohemiskt",
          image: ImageThemeBohem,
          category: category,
          text: "Bohemiska människoposter firar människans unika karaktär och självuttryck. Varje porträtt är en hyllning till individens frihet och autenticitet, ofta framhävda genom levande färger och eklektiska mönster."
        });
      } else if (style === "bohemian" && category === "creatures") {
        setDisplayThemeData({
          title: "Bohemiskt",
          image: ImageThemeBohem,
          category: category,
          text: "Bohemiska varelserskildringar tar inspiration från mystik, folklore och natur. Dessa bilder kombinerar traditionella mytiska varelser med djärva färger, eklektiska mönster och handgjorda detaljer, vilket ger varje varelse en särskild bohemisk känsla."
        });
      } else if (style === "bohemian" && category === "architecture") {
        setDisplayThemeData({
          title: "Bohemiskt",
          image: ImageThemeBohem,
          category: category,
          text: "Bohemisk arkitektur är en fusion av traditionella designelement och konstnärliga uttryck. Byggnaderna och strukturerna i dessa bilder präglas av naturliga material, lekfulla mönster och handgjorda detaljer, vilket ger varje landskap en känsla av värme och frihet."
        });
      } else if (style === "futuristic" && category === "nature") {
        setDisplayThemeData({
          title: "Framtid",
          image: ImageThemeFuture,
          category: category,
          text: "Framtidens natur avbildar en verklighet där teknologi och miljö sammansmälter. Dessa skildringar visar ofta landskap som är både bekanta och utomvärldsliga, med ljuvliga skogar som lever sida vid sida med teknologiska underverk."
        });
      } else if (style === "futuristic" && category === "animals") {
        setDisplayThemeData({
          title: "Framtid",
          image: ImageThemeFuture,
          category: category,
          text: "Framtida djurbilder föreställer hur evolutionen och teknologin kan påverka djurlivet. Från bio-mekaniska djur till genetiskt modifierade varelser, dessa avbildningar erbjuder en tankeväckande titt på vår planets möjliga framtid."
        });
      } else if (style === "futuristic" && category === "humans") {
        setDisplayThemeData({
          title: "Framtid",
          image: ImageThemeFuture,
          category: category,
          text: "Bilder av framtida människor ger en inblick i hur teknologiska framsteg kan forma mänsklig evolution, kultur och identitet. Dessa avbildningar kan omfatta allt från cybernetiska implantat till interstellära resenärer, reflekterande av människans strävan efter framsteg."
        });
      } else if (style === "futuristic" && category === "creatures") {
        setDisplayThemeData({
          title: "Framtid",
          image: ImageThemeFuture,
          category: category,
          text: "Framtidens varelser kombinerar det bekanta med det fantastiska. Med en blandning av biologi och teknologi, dessa skapelser är en vild spekulation om de sorters livsformer som kan existera i en avlägsen framtid."
        });
      } else if (style === "futuristic" && category === "architecture") {
        setDisplayThemeData({
          title: "Framtid",
          image: ImageThemeFuture,
          category: category,
          text: "Framtidens arkitektur avbildar en värld där byggnader inte bara är strukturer, utan levande, andande enheter. Genom att förena teknologi och design, dessa skildringar visar städer som är lika ekologiska som de är teknologiska, och bostäder som är integrerade med naturen på sätt vi bara kan drömma om."
        });
      } else if (style === "illustration" && category === "nature") {
        setDisplayThemeData({
          title: "Illustration",
          image: ImageThemeIllustration,
          category: category,
          text: "Illustrationer av naturen bjuder på en förskönad tolkning av vår omgivning. De varierar från detaljerade landskapsbilder till abstrakta skildringar av naturliga motiv, alla gjorda med en konstnärlig finess som ger dem liv och djup."
        });
      } else if (style === "illustration" && category === "animals") {
        setDisplayThemeData({
          title: "Illustration",
          image: ImageThemeIllustration,
          category: category,
          text: "Djurillustrationer spänner över en mängd olika stilar, från detaljerade skisser till lekfulla bilder. Varje illustration ger en unik och personlig hyllning till djurens karaktär och skönhet, ofta med en djupare symbolisk betydelse."
        });
      } else if (style === "illustration" && category === "humans") {
        setDisplayThemeData({
          title: "Illustration",
          image: ImageThemeIllustration,
          category: category,
          text: "Människoillustrationer är lika varierande som människorna de skildrar. Från minimalistiska porträtt till detaljerade skisser, dessa verk är djupgående studier av mänsklig form, uttryck och känsla."
        });
      } else if (style === "illustration" && category === "creatures") {
        setDisplayThemeData({
          title: "Illustration",
          image: ImageThemeIllustration,
          category: category,
          text: "Varelseillustrationer tar oss med på en resa genom fantasiens rikedom. Med varje penseldrag avslöjas en värld av mytiska varelser, fantasifulla skapelser, och sagolika monster, alla skapade med en omsorg för detalj och kreativitet."
        });
      } else if (style === "illustration" && category === "architecture") {
        setDisplayThemeData({
          title: "Illustration",
          image: ImageThemeIllustration,
          category: category,
          text: "Arkitekturillustrationer skildrar den konstnärliga tolkningen av byggnader, strukturer och städer. Från historiska monument till framtidens visioner, dessa bilder ger en djupgående insikt i arkitektens drömmande värld."
        });
      } else if (style === "fantasy" && category === "nature") {
        setDisplayThemeData({
          title: "Fantasy",
          image: ImageThemeFantasy,
          category: category,
          text: "Fantasy-naturposters erbjuder en resa till imaginära världar fulla av övernaturliga landskap och mystiska fenomen. Varje bild skildrar en plats där naturens lagar böjs och formar på de mest fantastiska sätt."
        });
      } else if (style === "fantasy" && category === "animals") {
        setDisplayThemeData({
          title: "Fantasy",
          image: ImageThemeFantasy,
          category: category,
          text: "Fantasy-djurposters innehåller en mängd mytiska och magiska varelser. Varje bild tar oss till en värld där djuren kan ha mänskliga egenskaper, magiska förmågor eller helt enkelt vara skapelser av ren fantasi."
        });
      } else if (style === "fantasy" && category === "humans") {
        setDisplayThemeData({
          title: "Fantasy",
          image: ImageThemeFantasy,
          category: category,
          text: "Fantasy-människoposters presenterar oss för karaktärer från en annan värld. Dessa bilder kan innehålla allt från riddare och trollkarlar till älvor och andra övernaturliga varelser, alla rikt detaljerade för att framkalla en stark känsla av fantasi."
        });
      } else if (style === "fantasy" && category === "creatures") {
        setDisplayThemeData({
          title: "Fantasy",
          image: ImageThemeFantasy,
          category: category,
          text: "Fantasy-varelsesposters dyker djupt in i den föreställda världens mystik. Dessa bilder skildrar mytiska varelser som drakar, fenixar, och troll, alla rikt detaljerade för att framkalla känslor av äventyr och undran."
        });
      } else if (style === "fantasy" && category === "architecture") {
          setDisplayThemeData({
            title: "Fantasy",
            image: ImageThemeFantasy,
            category: category,
            text: "Fantasy-arkitekturposters tar oss till otroliga byggnader och strukturer i en annan värld. Varje bild presenterar en plats där arkitekturen inte är begränsad av verklighetens lagar, men formad av konstnärens fantasi."
          });
        } else if (style === "photography" && category === "nature") {
          setDisplayThemeData({
            title: "Fotografi",
            image: ImageThemePhoto,
            category: category,
            text: "Naturfotoposters visar upp den orörda skönheten i vår värld, från majestätiska berg till tysta skogar. De belyser jordens underverk och bjuder in tittaren att uppskatta den naturliga skönheten omkring oss."
          });
        } else if (style === "photography" && category === "animals") {
          setDisplayThemeData({
            title: "Fotografi",
            image: ImageThemePhoto,
            category: category,
            text: "Djurfotoposters fångar den vilda andan hos världens mest fascinerande varelser. Från exotiska djur i avlägsna djungler till familjära husdjur i våra hem, dessa bilder firar djurens mångfald och den speciella plats de har i våra hjärtan."
          });
        } else if (style === "photography" && category === "humans") {
          setDisplayThemeData({
            title: "Fotografi",
            image: ImageThemePhoto,
            category: category,
            text: "Människofotoposters är djupgående skildringar av människolivet. Varje bild fångar en aspekt av mänsklig erfarenhet, från porträtt till gatufotografi, och erbjuder en inblick i våra liv och kulturer."
          });
        } else if (style === "photography" && category === "creatures") {
          setDisplayThemeData({
            title: "Fotografi",
            image: ImageThemePhoto,
            category: category,
            text: "Fotografi av varelser skildrar en fascinerande värld av mystik och fantasi. Dessa bilder fångar upp allt från mytiska varelser till fantasifulla skapelser, ofta med en rik detaljrikedom som lockar ögat att utforska."
          });
        } else if (style === "photography" && category === "architecture") {
          setDisplayThemeData({
            title: "Fotografi",
            image: ImageThemePhoto,
            category: category,
            text: "Arkitekturfotoposters fångar byggnadskonstens estetik på ett unikt sätt. Varje bild presenterar en byggnad eller struktur med ett konstnärligt öga, vilket framhäver linjer, former och ljusspel."
          });
        } else if (style === "pop-art" && category === "nature") {
          setDisplayThemeData({
            title: "Pop-Art",
            image: ImageThemePopArt,
            category: category,
            text: "Pop-Art naturmotiv kombinerar naturens skönhet med popkonstens livliga uttryck. Varje konstverk är en fest för ögat, med djärva färger och starka kontraster som gör naturen mer levande än någonsin."
          });
        } else if (style === "pop-art" && category === "animals") {
          setDisplayThemeData({
            title: "Pop-Art",
            image: ImageThemePopArt,
            category: category,
            text: "Pop-Art djurposter är en explosion av färg och stil. Varje verk tar ett djurmotiv och förvandlar det till ett levande uttryck av popkonst, med djärva färger, starka kontraster och ofta en touch av humor."
          });
        } else if (style === "pop-art" && category === "humans") {
          setDisplayThemeData({
            title: "Pop-Art",
            image: ImageThemePopArt,
            category: category,
            text: "Pop-Art människoporträtt är ett ikoniskt uttryck för samtida konst. De kombinerar ofta kända ansikten med djärva färger och grafiska former, skapar en omedelbar visuell attraktion som är karaktäristisk för popkonst."
          });
        } else if (style === "pop-art" && category === "creatures") {
          setDisplayThemeData({
            title: "Pop-Art",
            image: ImageThemePopArt,
            category: category,
            text: "Pop-Art varelseskonst tar fantasivarelser och förvandlar dem till levande, färgstarka konstverk. Med starka linjer, överdrivna former och djärva färgpaletter, dessa konstverk fångar ögat och skapar en oförglömlig visuell upplevelse."
      });
        } else if (style === "pop-art" && category === "architecture") {
          setDisplayThemeData({
            title: "Pop-Art",
            image: ImageThemePopArt,
            category: category,
            text: "Pop-Art arkitekturposter framhäver byggnadskonstens skönhet på ett unikt och samtida sätt. Genom att använda sig av ljusa färger, starka kontraster och ofta geometriska mönster."
      });
        }
  },[style, category]);


  const [selectedColor, setSelectedColor] = useState("")
  const [selectedShape, setSelectedShape] = useState("")
  const [selectedSize, setSelectedSize] = useState("")

  const [filteredUrlsDisplay, setFilteredUrlsDisplay] = useState([]);

  function convertCategory(category){
    if (category==="nature"){
      return "Natur"
    }
    if (category==="animals"){
      return "Djur"
    }
    if (category==="humans"){
      return "Människor"
    }
    if (category==="creatures"){
      return "Varelser"
    }
    if (category==="nature"){
      return "Natur"
    }
    if (category==="architecture"){
      return "Natur"
    }
    return ""
  }

  

  useEffect(() => {
    // Filters color, shape, size is all '' from the beginning, if any of the variable is not '' then it should filter on this too
    
    
    
  
    // Array with json which should be filtered
    
  
    // If signedUrls is defined, proceed with the filtering
    if (signedUrls) {
      const filteredUrls = signedUrls.filter((item) => {
  
        let colorMatch = true;
        let shapeMatch = true;
        let sizeMatch = true;
  
        // Check if a color is selected and if the item has that color
        if (selectedColor !== '') {
          colorMatch = item.colors.includes(selectedColor);
        }
  
        // Check if a shape is selected and if the item has that shape
        // Check if a size is selected and if the item has that size
        // Assuming size corresponds to aspectRatio
        if (selectedShape !== '') {
          shapeMatch = item.aspectRatio === selectedShape;
        }
  
        // If the item matches all selected filters, include it in the filtered array
        //return colorMatch && shapeMatch && sizeMatch;
        return colorMatch && shapeMatch && sizeMatch;
      });
  
      // If no items were found, use the original array
      if (filteredUrls.length === 0) {
        
        
      } else {
        
        
        setFilteredUrlsDisplay(filteredUrls)
        
      }
    } else {
      
    }
  
  }, [selectedColor, selectedShape, selectedSize, signedUrls]);
  


  const [frameType, setFrameType] = useState("no_margin");
  const [frameCode, setFrameCode] = useState("f2");
  const framedImageIndex = (frameCode, frameType) => {
    let frameIndex = 0; // Define frameIndex here before the if statement
  
    if (frameCode === "f1") {
      // Your logic for f1
      frameIndex = 0;
    } else if (frameCode === "f2") {
      // Your logic for f2
      frameIndex = 1;
    } else if (frameCode === "f3") {
      // Your logic for f3
      frameIndex = 2;
    } else if (frameCode === "f4") {
      // Your logic for f4
      frameIndex = 3;
    } else if (frameCode === "f5") {
      // Your logic for f5
      frameIndex = 4;
    } else if (frameCode === "f6") {
      // Your logic for f6
      frameIndex = 5;
    } else if (frameCode === "f7") {
      // Your logic for f7
      frameIndex = 6;
    } else if (frameCode === "f8") {
      // Your logic for f8
      frameIndex = 7;
    }
  
    if(frameType==="margin"){
      frameIndex += 8;
    }
    return frameIndex;
  };





  const drawerContent = () => {
    return (



      <div>
        <Divider />
        {drawerMode === "filter" ? (
          <div>
            <div
            style={{
              marginBottom:"40px",

            }}
            >
              <ColorFilter
              isMobileView={isMobileView}
              setSelectedColor={setSelectedColor}
              selectedColor={selectedColor}
              />
            </div>
            <div
            style={{
              marginBottom:"40px"
            }}
            >
              <ShapeFilter
              setSelectedShape={setSelectedShape}
              selectedShape={selectedShape}
              isMobileView={isMobileView}
              />
            </div>
            <div>
              <SizeFilter
              isMobileView={isMobileView}
              setSelectedSize={setSelectedSize}
              selectedSize={selectedSize}
              />
            </div>
          </div>
        ) : (
          <div>
            <SortingFilter
            isMobileView={isMobileView}
            setSelectedSortOn={setSelectedSortOn}
            />
          </div>
        )}
      </div>
    );
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  }
  const scrollToTopSmooth = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToPosition = (scrollPosition) => {

    window.scrollTo(0, scrollPosition);
  };


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            setShowFixedIcons(true);
          } else {
            setShowFixedIcons(false);
          }
        });
      },
      { threshold: 0 }
    );

    if (filterButtonRef.current && sortButtonRef.current) {
      observer.observe(filterButtonRef.current);
      observer.observe(sortButtonRef.current);
    }

    return () => {
      if (filterButtonRef.current && sortButtonRef.current) {
        observer.unobserve(filterButtonRef.current);
        observer.unobserve(sortButtonRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (fixedIconsRef.current) {
      if (showFixedIcons) {
        gsap.to(fixedIconsRef.current, {
          duration: 0.5,
          y: 0,
          autoAlpha: 1,
        });
      } else {
        gsap.to(fixedIconsRef.current, {
          duration: 0.5,
          y: -50,
          autoAlpha: 0,
        });
      }
    }
  }, [showFixedIcons]);


  useEffect(() => {
    console.log("style:",style)
    console.log("category:",category)

      if(scrollPosition!==0){
        scrollToPosition(scrollPosition)

        
        //setScrollPosition(0)
      }
      else{
        if(style!=="" && category===undefined){
          scrollToTopSmooth()
    
        }
        if(typeof style === "string" && typeof category === "string"){
          scrollToTopSmooth();
        }
      }
   
  }, [style, category]);

// useEffect(() => {

//   scrollToPosition(scrollPosition);
  
// }, [scrollPosition]);



useEffect(() => {
  if(scrollPosition !== 0){
    console.log("Should scroll down now");
    setTimeout(() => {
      scrollToPosition(scrollPosition);
      setScrollPosition(0)
    }, 20); // Delay of 100ms
  }
}, []);


useEffect(() => {
  scrollToTopSmooth();
  
}, [searchResult]);

 

  useEffect(() => {
    if((style)===undefined){

    }
    else{
      if(style?.[0] === "1"){
        setDisplayButtons("hidden")
  
      }
      else{
        setDisplayButtons("visible")
      }
    }


  }, [style]);

  const categoryLabels = {
    'animals': 'Djur', 'animals-1': 'Djur', 'nature': 'Natur', 'nature-1': 'Natur',
    'humans': 'Människor', 'abstract': 'Abstrakt', 'illustration': 'Illustration',
    'photography': 'Fotografi', 'futuristic': 'Cyberpunk', 'fantasy': 'Fantasy',
    'pop-art': 'Pop-art', 'bohemian': 'Bohemisk', 'topplista': 'Topplista',
    'nyheter': 'Nyheter', 'rabatt': 'REA',
  };

  const getSeoTitle = () => {
    if (style?.[0] === '1') return null; // info pages handle their own SEO
    const styleLabel = categoryLabels[style] || style;
    if (category) {
      const catLabel = categoryLabels[category] || category;
      return `${catLabel} ${styleLabel} Posters`;
    }
    return `${styleLabel} Posters - Köp Online`;
  };

  const getSeoDescription = () => {
    const styleLabel = categoryLabels[style] || style;
    if (category) {
      const catLabel = categoryLabels[category] || category;
      return `Utforska vårt utbud av ${catLabel.toLowerCase()} posters i ${styleLabel.toLowerCase()} stil. Prisvärda konsttryck med snabb leverans i Sverige.`;
    }
    return `Köp ${styleLabel.toLowerCase()} posters online på PosterTopia. Stilfulla och prisvärda konsttryck med snabb leverans i hela Sverige.`;
  };

  const currentPath = category ? `/${style}/${category}` : `/${style}`;
  const breadcrumbs = [{ name: 'Hem', path: '/' }];
  if (style && style[0] !== '1') {
    breadcrumbs.push({ name: categoryLabels[style] || style, path: `/${style}` });
    if (category) {
      breadcrumbs.push({ name: categoryLabels[category] || category, path: currentPath });
    }
  }

  return (

    <div>
      {style && style[0] !== '1' && (
        <SEO
          title={getSeoTitle()}
          description={getSeoDescription()}
          path={currentPath}
          jsonLd={[
            createCollectionSchema({
              name: getSeoTitle(),
              description: getSeoDescription(),
              url: `https://www.postertopia.se${currentPath}`,
            }),
            createBreadcrumbSchema(breadcrumbs),
          ]}
        />
      )}
      {/* ── Promo banner (auto-rolling weekly) ── */}
      {displayThemeData.category !== "" && style?.[0] !== "1" ? (
        <Link to="/rabatt" style={{ textDecoration: 'none' }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: isMobileView ? '12px' : '24px', flexWrap: 'wrap',
            width: '100%', padding: isMobileView ? '14px 16px' : '16px 24px',
            background: 'linear-gradient(135deg, #fe8627, #ff6b00)',
            color: '#fff', marginBottom: '16px',
          }}>
            <div style={{ textAlign: 'center' }}>
              <h3 style={{ margin: 0, fontSize: isMobileView ? '16px' : '20px', fontWeight: 700 }}>
                30% rabatt på posters
              </h3>
            </div>
            <Countdown />
          </div>
        </Link>
      ) : null}

    <div>
      {/* ── Category hero banner ── */}
      {displayThemeData.category !== "" && (!style || (style && style[0] !== "1")) ? (
        <div style={{
          position: 'relative',
          width: isMobileView ? '94%' : isTabletView ? '88%' : '65%',
          marginLeft: isMobileView ? '3%' : isTabletView ? '6%' : 'calc(200px + (100% - 200px - 65%) / 2)',
          marginRight: 'auto',
          marginBottom: '30px',
          borderRadius: '16px',
          overflow: 'hidden',
          minHeight: isMobileView ? '200px' : '280px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <img
            style={{
              position: 'absolute', inset: 0,
              width: '100%', height: '100%', objectFit: 'cover',
            }}
            src={displayThemeData.image}
            alt={displayThemeData.title || 'Category'}
          />
          {/* Dark overlay for readability */}
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.45) 50%, rgba(0,0,0,0.3) 100%)',
          }} />

          {/* Text content */}
          <div style={{
            position: 'relative', zIndex: 1, textAlign: 'center',
            padding: isMobileView ? '28px 20px' : '40px 32px',
            color: '#fff', maxWidth: '650px',
          }}>
            {/* Breadcrumb */}
            <p style={{
              margin: '0 0 12px', fontSize: '13px', fontWeight: 600,
              textTransform: 'uppercase', letterSpacing: '0.12em',
              color: 'rgba(255,255,255,0.9)',
            }}>
              Posters ▸ {displayThemeData.title}
              {displayThemeData.category ? ` ▸ ${convertCategory(displayThemeData.category)}` : ''}
            </p>

            <h2 style={{
              margin: '0 0 12px', fontSize: isMobileView ? '26px' : '36px', fontWeight: 700,
              textShadow: '0 2px 8px rgba(0,0,0,0.4)',
            }}>
              {displayThemeData.category !== "" ? convertCategory(displayThemeData.category) : displayThemeData.title}
            </h2>

            {displayThemeData.text && (
              <p style={{
                margin: 0, fontSize: isMobileView ? '14px' : '15px',
                lineHeight: 1.6, color: 'rgba(255,255,255,0.95)',
                textShadow: '0 1px 4px rgba(0,0,0,0.3)',
              }}>
                {displayThemeData.text}
              </p>
            )}
          </div>
        </div>
      ) : null}
      {/* ── Filter / Ram / Sort toolbar ── */}
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        gap: isMobileView ? '8px' : '12px', marginBottom: '24px',
        flexWrap: 'wrap', padding: '0 12px',
        visibility: displayButtons,
      }}>
        {/* Filtrera button */}
        <button
          ref={filterButtonRef}
          onClick={() => openDrawer("filter")}
          style={{
            display: 'flex', alignItems: 'center', gap: '8px',
            padding: isMobileView ? '10px 16px' : '10px 22px',
            borderRadius: '12px', cursor: 'pointer',
            border: '1.5px solid #e0e0e0', backgroundColor: '#fff',
            fontSize: '13px', fontWeight: 600, color: '#333',
            transition: 'all 0.2s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
          onMouseOver={(e) => { e.currentTarget.style.borderColor = '#161825'; e.currentTarget.style.boxShadow = '0 3px 10px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
          onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e0e0e0'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(0)'; }}
        >
          <TuneIcon style={{ fontSize: 18, color: '#555' }} />
          Filtrera
        </button>

        {/* Ram button */}
        <button
          onClick={(e) => { e.stopPropagation(); toggleDrawerFrame(); }}
          style={{
            display: 'flex', alignItems: 'center', gap: '8px',
            padding: isMobileView ? '10px 16px' : '10px 22px',
            borderRadius: '12px', cursor: 'pointer',
            border: '1.5px solid #e0e0e0', backgroundColor: '#fff',
            fontSize: '13px', fontWeight: 600, color: '#333',
            transition: 'all 0.2s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
          onMouseOver={(e) => { e.currentTarget.style.borderColor = '#161825'; e.currentTarget.style.boxShadow = '0 3px 10px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
          onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e0e0e0'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(0)'; }}
        >
          <WallpaperIcon style={{ fontSize: 18, color: '#555' }} />
          Ram
        </button>

        {/* Sortera button */}
        <button
          ref={sortButtonRef}
          onClick={() => openDrawer("sort")}
          style={{
            display: 'flex', alignItems: 'center', gap: '8px',
            padding: isMobileView ? '10px 16px' : '10px 22px',
            borderRadius: '12px', cursor: 'pointer',
            border: '1.5px solid #e0e0e0', backgroundColor: '#fff',
            fontSize: '13px', fontWeight: 600, color: '#333',
            transition: 'all 0.2s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
          onMouseOver={(e) => { e.currentTarget.style.borderColor = '#161825'; e.currentTarget.style.boxShadow = '0 3px 10px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
          onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e0e0e0'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(0)'; }}
        >
          <FilterListIcon style={{ fontSize: 18, color: '#555' }} />
          Sortera
        </button>

        {/* Frame toggle switch */}
        <div style={{ display: 'flex', alignItems: 'center', visibility: displayButtons }}>
          <FormControlLabel
            control={<Switch checked={toggleState} onChange={handleToggleChange} color="primary" />}
            label={<span style={{ fontSize: '12px', color: '#666' }}>Ram</span>}
            style={{ marginRight: 0 }}
          />
        </div>
      </div>

      {/* ── Floating toolbar (appears on scroll) ── */}
      {displayFixedButtons && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          style={{
            position: 'fixed', top: '100px',
            left: '50%', transform: 'translateX(-50%)',
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '6px 8px', zIndex: 1200,
            backgroundColor: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
            visibility: displayButtons,
          }}
        >
          <button
            onClick={() => openDrawer("filter")}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              width: 42, height: 42, borderRadius: '12px', border: 'none',
              backgroundColor: 'transparent', cursor: 'pointer',
              transition: 'background-color 0.15s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            title="Filtrera"
          >
            <TuneIcon style={{ fontSize: 20, color: '#333' }} />
          </button>
          <div style={{ width: 1, height: 24, backgroundColor: '#e0e0e0' }} />
          <button
            onClick={(e) => { e.stopPropagation(); toggleDrawerFrame(); }}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              width: 42, height: 42, borderRadius: '12px', border: 'none',
              backgroundColor: 'transparent', cursor: 'pointer',
              transition: 'background-color 0.15s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            title="Ram"
          >
            <WallpaperIcon style={{ fontSize: 20, color: '#333' }} />
          </button>
          <div style={{ width: 1, height: 24, backgroundColor: '#e0e0e0' }} />
          <button
            onClick={() => openDrawer("sort")}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              width: 42, height: 42, borderRadius: '12px', border: 'none',
              backgroundColor: 'transparent', cursor: 'pointer',
              transition: 'background-color 0.15s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            title="Sortera"
          >
            <FilterListIcon style={{ fontSize: 20, color: '#333' }} />
          </button>
        </motion.div>
      )}


      
      <Gallery

        loadCount={loadCount}
        setLoadCount={setLoadCount}


        discountPercentage={discountPercentage}
        handleScrollPosition={handleScrollPosition}
        setScrollPosition={setScrollPosition}
        searchResult={searchResult}
        imageDisplayUrls={imageDisplayUrls}
        imageDisplayUrl={imageDisplayUrl}
        searchValue={searchValue}
        favoritePoster={favoritePoster}
        setFavoritePoster={setFavoritePoster}
        frameCode={frameCode}
        frameType={frameType}
        frameIndex={framedImageIndex(frameCode, frameType)}
        isMobileView={isMobileView}
        signedUrls={filteredUrlsDisplay}
        setImageDisplayUrls={setImageDisplayUrls}
        selectedStyle={style || ""}
        selectedCategory={category || ""}
        toggleState={toggleState}
        onImageClick={onImageClick}
      />
      <div
      style={{
        position: "relative",
        left: isMobileView? "20px": "10%",
        width: "90vw"
      }}
      >
      {style === '1-kontakta-oss' && <ContactComponent />}
      {style === '1-vanliga-fragor' && <CommonQuestions />}
      {style === '1-kopvillkor' && <PurchaseConditions />}
      {style === '1-leverans' && <DeliveryInformation />}
      {style === '1-cookiepolicy' && <Cookiepolicy />}
      {style === '1-integritetspolicy' && <IntegrityPolicy />}
      {style === '1-om-oss' && <AboutUs />}
      {style === '1-posters' && <PosterInfo />}
      {style === '1-tack' && <ThankYou />}
      {style === '1-misslyckad-betalning' && <PaymentFailed />}
      {style === '1-tips-till-tavelvaggen' && <PageUnderConstruction />}
      {style === '1-affischer-planscher' && <PageUnderConstruction />}
      {style === '1-poster-store' && <PageUnderConstruction />}
      {style === 'posterpaket' && <PageUnderConstruction />}
      </div>


    <CustomOverlayDrawer
    isMobileView={isMobileView}
    setFrameType={setFrameType}
    setFrameCode={setFrameCode}
    openFrameMenu={openFrameMenu}
    handleToggleChange={toggleDrawerFrame}
    setToggleState={setToggleState}
    />

      
  
  <Drawer anchor="right" open={drawerOpen} onClose={closeDrawer}>
    <div style={{
      width: isMobileView ? '85vw' : '380px',
      height: '100%', display: 'flex', flexDirection: 'column',
      backgroundColor: '#fff',
    }}>
      {/* Drawer header */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '20px 24px 16px', borderBottom: '1px solid #f0f0f0',
        flexShrink: 0,
      }}>
        <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: '#161825' }}>
          {drawerMode === 'filter' ? 'Filtrera' : 'Sortera'}
        </h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button
            onClick={() => setDrawerMode(drawerMode === "filter" ? "sort" : "filter")}
            style={{
              display: 'flex', alignItems: 'center', gap: '4px',
              padding: '6px 12px', borderRadius: '8px', border: '1px solid #e0e0e0',
              backgroundColor: '#fafafa', cursor: 'pointer', fontSize: '12px',
              fontWeight: 500, color: '#555', transition: 'all 0.15s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
          >
            <SyncIcon style={{ fontSize: 16 }} />
            {drawerMode === 'filter' ? 'Sortera' : 'Filtrera'}
          </button>
          <button
            onClick={closeDrawer}
            style={{
              width: 34, height: 34, borderRadius: '50%', border: 'none',
              backgroundColor: '#f5f5f5', cursor: 'pointer', display: 'flex',
              alignItems: 'center', justifyContent: 'center', fontSize: '16px',
              color: '#666', transition: 'background-color 0.15s',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#eee'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
          >
            ✕
          </button>
        </div>
      </div>

      {/* Drawer content */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
        {drawerMode === "filter" ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
            <div>
              <p style={{
                fontSize: '12px', fontWeight: 600, textTransform: 'uppercase',
                letterSpacing: '0.1em', color: '#888', margin: '0 0 14px 0',
              }}>
                Färg
              </p>
              <ColorFilter
                isMobileView={isMobileView}
                setSelectedColor={setSelectedColor}
                selectedColor={selectedColor}
              />
            </div>
            <div>
              <p style={{
                fontSize: '12px', fontWeight: 600, textTransform: 'uppercase',
                letterSpacing: '0.1em', color: '#888', margin: '0 0 14px 0',
              }}>
                Format
              </p>
              <ShapeFilter
                setSelectedShape={setSelectedShape}
                selectedShape={selectedShape}
                isMobileView={isMobileView}
              />
            </div>
            <div>
              <p style={{
                fontSize: '12px', fontWeight: 600, textTransform: 'uppercase',
                letterSpacing: '0.1em', color: '#888', margin: '0 0 14px 0',
              }}>
                Storlek
              </p>
              <SizeFilter
                isMobileView={isMobileView}
                setSelectedSize={setSelectedSize}
                selectedSize={selectedSize}
              />
            </div>
          </div>
        ) : (
          <div>
            <p style={{
              fontSize: '12px', fontWeight: 600, textTransform: 'uppercase',
              letterSpacing: '0.1em', color: '#888', margin: '0 0 14px 0',
            }}>
              Sortera efter
            </p>
            <SortingFilter
              isMobileView={isMobileView}
              setSelectedSortOn={setSelectedSortOn}
            />
          </div>
        )}
      </div>
    </div>
  </Drawer>
<div
style={{
  marginLeft: isTabletView2?"0px":"10vw"
}}
>
        <div
        style={{
          marginLeft: isMobileView2?"0px":"160px"
        }}>
        <SubSectionsCard
        isMobileView={isMobileView2}/>
        </div>
        <div
        style={{

        }}
        >
        {isTabletView2?<BottomSectionMobile setCookieConsentGiven={setCookieConsentGiven} setOpenCookieBar={setOpenCookieBar} />:<BottomSection setCookieConsentGiven={setCookieConsentGiven} setOpenCookieBar={setOpenCookieBar}/>}


        </div>

        </div>


        </div>

        {scrollPosition!==0 && isMobileView?<LoadingOverlay duration={700}/>:null}
        </div>
);
};

export default GalleryPage;

  



